import React from "react";
import PropTypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";

const RatingStar = ({
    starColors,
    avgRating,
    isLastStarHalfFilled = false
}) => {

    const starsMap = (rating, colors) => {
        const ratingMod = rating % parseInt(rating);
        const arr = [0, 0, 0, 0, 0];
        return arr.map((i, index) => {
            const absoluteRating = rating - ratingMod;
            if (index >= absoluteRating) {
                return colors.transparent;
            } else if (isNaN(absoluteRating)) {
                return colors.transparent;
            } else if (index === arr.length - NUMBER.ONE && isLastStarHalfFilled) {
                return colors.halfFilled;
            } else {
                return colors.fill;
            }
        });
    };

    const getRatingText = (rating) => {
        const ratingText = Math.round(rating);
        return ratingText;
    };

    return (
        <React.Fragment>
            {starsMap(getRatingText(avgRating), starColors)
                .map((color, index) => <img key={index} alt={`star_${index}`} src={color} />)}
        </React.Fragment>
    );
};

RatingStar.propTypes = {
    starColors: PropTypes.object,
    avgRating: PropTypes.number,
    isLastStarHalfFilled: PropTypes.bool
};

export default RatingStar;

